import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PhysicalInfraPageComponent } from './components/physical-infra-page/physical-infra-page.component';
import { AdminPhysicalInfraComponent } from './components/admin-physical-infra/admin-physical-infra.component';
import { AdminGuard } from 'src/app/services/admin.guard';

const routes: Routes = [
  {
    path: ':name', component: PhysicalInfraPageComponent, data: { title: '' }
  },
  {
    path: '',canActivate:[AdminGuard],  component: AdminPhysicalInfraComponent, data: { title: '' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PhysicalInfrastructureRoutingModule { }
